"use client";

export function ThreadMediaSkeleton() {
  return (
    <div className="flex-1 h-full flex items-center justify-center animate-pulse">
      <div className="w-full aspect-video bg-background-card rounded-2xl" />
    </div>
  );
}
